module.exports = __webpack_public_path__ + "img/hungary.bc0e0829.webp";